import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { withStyles, createStyles, makeStyles, useTheme } from '@material-ui/styles';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Input,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import { v4 as uuidv4 } from 'uuid';
import Controls from '../../components/controls/Controls';
import { baseUrl, userDept, Country, userStatuses } from '../../utils/constants';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: theme.spacing(3)
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

// function getStyles(name, personName, theme) {
//   return {
//     fontWeight:
//       personName.indexOf(name) === -1
//         ? theme.typography.fontWeightRegular
//         : theme.typography.fontWeightMedium
//   };
// }

// function getAllStyles(name, values, theme) {
//   return {
//     fontWeight:
//       values.indexOf(name) === -1
//         ? theme.typography.fontWeightRegular
//         : theme.typography.fontWeightMedium
//   };
// }

export default function CreateUser() {
  const classes = useStyles();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [status, setStatus] = useState('');
  const [branchList, setBranchesList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [dept, setDept] = useState('');
  const [personName, setPersonName] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [roles, setRoles] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getUserManagementLookups();
  }, []);

  const UserSchema = Yup.object().shape({
    userName: Yup.string().required('User Name is required'),
    password: Yup.string().required('Password is required'),
    firstName: Yup.string().required('First Name is required'),
    emailAddress: Yup.string().email('Invalid email'),
    status: Yup.number().required('Status is required'),
    defaultCountry: Yup.number().required('Country Reference ID is required')
  });

  const now = new Date().toISOString();

  const formik = useFormik({
    initialValues: {
      userName: '',
      password: '',
      defaultCountry: 1,
      firstName: '',
      surname: '',
      idNumber: '',
      emailAddress: '',
      cellNumber: '',
      status: 1,
      lastLogIn: now,
      passwordPolicy: 0,
      lastPasswordChange: now,
      systemLanguage: 0,
      userType: 0,
      passwordToken: '',
      description: '',
      supervisorRefId: 0,
      branchRefId: 0,
      extension: '',
      oldRefId: 0,
      dept: 1
    },
    validationSchema: UserSchema,
    onSubmit: (values) => {
      encryptPassword(values.password)
        .then((replyMessage) => {
          const updatedValues = { ...values, password: replyMessage };

          saveUser(updatedValues);
        })
        .catch((error) => {
          console.error('Error encrypting password:', error);
          notifyPopup(`Error encrypting password: ${error.message}`, 'error');
        });
    }
  });

  const encryptPassword = async (password) => {
    try {
      const response = await fetch(`${baseUrl}/api/ServiceAuthentication/EncryptPassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(password)
      });
      console.log('Now encrypting tjis', password);
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to encrypt password');
      }
      return data.replyMessage;
    } catch (error) {
      console.error('Encryption error:', error);
      throw error;
    }
  };

  const saveUser = (user) => {
    console.log('user to save', user);
    const payload = {
      ...user,
      id: uuidv4(),
      status: parseInt(user.status, 10),
      dept: parseInt(user.dept, 10),
      //   countryRefId: parseInt(user.countryRefId, 10),
      supervisorRefId: user.supervisorRefId ? parseInt(user.supervisorRefId, 10) : null,
      oldRefId: user.oldRefId ? parseInt(user.oldRefId, 10) : null,
      roles,
      templates
      //   passwordToken: uuidv4(),
      //   lastLogIn: user.lastLogIn ? new Date(user.lastLogIn).toISOString() : null,
      //   lastPasswordChange: user.lastPasswordChange
      //     ? new Date(user.lastPasswordChange).toISOString()
      //     : null
    };

    console.log('Payload to be sent:', JSON.stringify(payload));
    setLoading(true);
    fetch(`${baseUrl}/api/userManagement/addNewUser`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(
        (result) => {
          notifyPopup('User Saved Successfully!', 'success');
          setLoading(false);
          navigate('/settings/users');
        },
        (error) => {
          notifyPopup(`Error in Saving User!: ${error.message}`, 'error');
          setLoading(false);
        }
      )
      .catch((error) => {
        notifyPopup(`Error in Saving User!: ${error.message}`, 'error');
        setLoading(false);
      });
  };

  const getUserManagementLookups = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/UserManagement/getUserManagementLookups`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('data lookups', data);

      setTemplateList(data.templates?.lookupList || []);
      setRolesList(data.roles?.lookupList || []);
      setUserTypeList(data.userTypes?.lookupList || []);
      setBranchesList(data.branches?.lookupList || []);
    } catch (error) {
      console.error('Error fetching lookups:', error);
      notifyPopup(`Failed to load user data: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: notifyMessage,
      type: notifyType
    });
  };

  const handleChange = (event) => {
    setPersonName(event.target.value);
  };

  const handleTemplateChange = (event) => {
    setTemplates(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRoles(event.target.value);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography variant="subtitle1" gutterBottom>
                New User
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="userName" label="User Name" autoComplete="off" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input
                    name="password"
                    label="Password"
                    type="password"
                    inputProps={{
                      autoComplete: 'new-password'
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="firstName" label="First Name" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="surname" label="Surname" />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input name="idNumber" label="ID Number" />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input
                    name="emailAddress"
                    label="Email Address"
                    type="email"
                    autocomplete="new-password"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input name="cellNumber" label="Cell Number" />
                </Grid>

                {/* <Grid item xs={12} sm={4}>
                  <Controls.SelectJson name="dept" label="Department" options={userDept} />
                </Grid> */}
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="countrylabel">User Type</InputLabel>
                    <Select
                      value={formik.values.userType}
                      name="userType"
                      //   style={{ width: '40%' }}
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('userType', e.target.value);
                      }}
                    >
                      <MenuItem key="" value="0">
                        Select User Type...
                      </MenuItem>
                      {userTypeList.map((item) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="branchlabel">Branch</InputLabel>
                    <Select
                      value={formik.values.branch}
                      name="branch"
                      //   style={{ width: '40%' }}
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('branch', e.target.value);
                      }}
                    >
                      <MenuItem key="" value="0">
                        Select Branch...
                      </MenuItem>
                      {branchList.map((item) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson
                    name="defaultCountry"
                    label="Country Reference ID"
                    options={Country}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="rolesLabel">Linked Roles</InputLabel>
                    <Select
                      labelId="rolesLabel"
                      name="roles"
                      multiple
                      value={roles}
                      onChange={handleRoleChange}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selectedRole) => (
                        <div className={classes.chips}>
                          {console.log('selected rol is ', selectedRole)}
                          {console.log('selected rolesList is ', rolesList)}
                          {selectedRole.map((values, key) => (
                            <Chip key={key} label={rolesList[key].value} className={classes.chip} />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {rolesList.map((item) => (
                        <MenuItem
                          key={item.key}
                          value={item.key}
                          //   style={getAllStyles(item.value, templates, theme)}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="templateLabel">Linked Templates</InputLabel>
                    <Select
                      labelId="templateLabel"
                      name="templates"
                      multiple
                      value={templates}
                      onChange={handleTemplateChange}
                      input={<Input id="select-multiple-chip" />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {console.log('selected is ', selected)}
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={templateList[value].value}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {templateList.map((item) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} sm={12}>
                  <Controls.Input name="description" label="Description" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.InputNumber name="supervisorRefId" label="Supervisor Reference ID" />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Controls.Input name="extension" label="Extension" />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.Input name="passwordToken" label="Password Token" disabled />
                </Grid> */}

                <Grid item xs={12} sm={4}>
                  <Controls.SelectJson name="status" label="Status" options={userStatuses} />
                </Grid>
                <Grid item xs={12} />
              </Grid>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={4}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    disabled={loading}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          </FormikProvider>
        </CardContent>
      </Card>
    </Container>
  );
}
